import { gql } from '@apollo/client'

export const ACCOUNT_DELETION = gql`
  mutation AccountDeletion($userId: ID!) {
    accountDeletion(userId: $userId) {
      id
    }
  }
`
